document.addEventListener('DOMContentLoaded', function() {
    return; // DISABLED
    // --- CONFIGURATION ---
    const appContainerSelector = '[data-essential-upsell-element="products"]'; 
    const titleSelector = '[data-essential-upsell-element="title"]'; 
    const productPriceSelector = '[data-essential-upsell-element="regular-price"]';
    
    // Subtotal Selectors
    const subtotalLabelSelector = '.totals__subtotal'; 
    const subtotalValueSelector = '.totals__subtotal-value'; 

    // --- HELPERS ---
    function parsePrice(priceString) {
        return parseFloat(priceString.replace(/[^0-9.]/g, ''));
    }

    function formatMoney(amount) {
        return '$' + amount.toFixed(2);
    }

    // --- LOGIC 1: HEADER TEXT ---
    function updateUpsellHeader(cart) {
        const count = cart.item_count;
        let newText = (count < 2) ? "Buy 1 more to save 15% & Free Gift" : "Last chance to save 15%";

        const titleElement = document.querySelector(titleSelector);
        if (titleElement && titleElement.innerText !== newText) {
            titleElement.innerText = newText;
        }
    }

    // --- LOGIC 2: CART SUBTOTAL (Strictly 2+ Items) ---
    // The actual cart total only changes if they REALLY have 2 items.
    function updateCartSubtotal(cart) {
        const labels = document.querySelectorAll(subtotalLabelSelector);
        const values = document.querySelectorAll(subtotalValueSelector);
        const count = cart.item_count;
        const totalPrice = cart.total_price / 100;

        if (count >= 2) {
            // Apply Badge & Discount to Subtotal
            labels.forEach(label => {
                if (!label.querySelector('.upsell-discount-badge')) {
                    const badge = document.createElement('span');
                    badge.className = 'upsell-discount-badge';
                    badge.innerText = '15% OFF';
                    badge.style.marginLeft = '10px'; 
                    badge.style.verticalAlign = 'middle';
                    label.appendChild(badge);
                }
            });

            values.forEach(value => {
                if (!value.getAttribute('data-original-html')) {
                    value.setAttribute('data-original-html', value.innerHTML);
                }
                const discountedTotal = totalPrice * 0.85; 
                value.innerHTML = `
                    <s class="upsell-compare-price">${formatMoney(totalPrice)}</s> 
                    ${formatMoney(discountedTotal)} USD
                `;
            });

        } else {
            // Revert Subtotal
            labels.forEach(label => {
                const badge = label.querySelector('.upsell-discount-badge');
                if (badge) badge.remove();
            });

            values.forEach(value => {
                if (value.getAttribute('data-original-html')) {
                    value.innerHTML = value.getAttribute('data-original-html');
                }
            });
        }
    }

    // --- LOGIC 3: UPSELL PRODUCTS (1+ Items) ---
    // Show the discount "Before they add it" (if they already have 1).
    function updateProductPrices(cart) {
        const priceElements = document.querySelectorAll(productPriceSelector);
        const count = cart.item_count;

        priceElements.forEach(el => {
            // Store Original HTML
            if (!el.getAttribute('data-original-html')) {
                el.setAttribute('data-original-html', el.innerHTML);
            }

            // CHANGE: Check if count is 1 or more. 
            // If I have 1 item, adding this Upsell makes it 2, so show the deal.
            if (count >= 1) {
                
                // Only apply if not already applied
                if (!el.querySelector('.upsell-discount-badge')) {
                    const originalPriceText = el.getAttribute('data-original-html').trim();
                    const originalPriceVal = parsePrice(originalPriceText);

                    if (!isNaN(originalPriceVal)) {
                        const discountedPrice = originalPriceVal * 0.85;
                        
                        el.innerHTML = `
                            <span class="upsell-compare-price">${originalPriceText}</span>
                            <span>${formatMoney(discountedPrice)}</span>
                            <span class="upsell-discount-badge">15% OFF</span>
                        `;
                    }
                }

            } else {
                // Revert if cart is empty (0 items)
                const originalHtml = el.getAttribute('data-original-html');
                if (originalHtml) {
                    el.innerHTML = originalHtml;
                }
            }
        });
    }

    // --- MAIN RUNNER ---
    function runCustomLogic() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            updateUpsellHeader(cart);
            updateCartSubtotal(cart);
            updateProductPrices(cart);
        });
    }

    // --- OBSERVERS ---
    const observer = new MutationObserver((mutations) => {
        if (document.querySelector(appContainerSelector) || document.querySelector(subtotalLabelSelector)) {
            runCustomLogic();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    
    document.addEventListener('cart:updated', () => {
       setTimeout(() => { runCustomLogic(); }, 500);
    });
});